import axios from "axios";

const asaasVerifyCustomer = async ({
  document,
  name,
}) => {
  try {
    const { data } = await axios.post(
      `/asaas/verify/user`,
      {
        document,
        name,
      }
    );

    if (!data?.success) {
      return {
        success: false,
        message: "Cliente não encontrado",
        customerExists: false,
        asaasCustomerId: null,
      };
    }

    return {
      success: true,
      message: "Cliente encontrado",
      customerExists: true,
      asaasCustomerId: data?.asaasCustomerId,
    };
  } catch (error) {
    console.error("Erro no serviço asaasVerifyCustomer:", error);
    return {
      success: false,
      message: "Erro ao verificar cliente",
      customerExists: false,
      asaasCustomerId: null,
      error: error.response?.data || error.message,
    };
  }
};

export { asaasVerifyCustomer };